import { ContactFilterConditionInterface } from '../types/contact-filter-interface'

export const getFilterApi = (conditions: ContactFilterConditionInterface[]) =>
  conditions
    .map((el, idx) => {
      return Object.keys(el).map(
        e =>
          `&filter[conditions][${idx}][${e}]=${encodeURIComponent(
            el[e as keyof ContactFilterConditionInterface] as string,
          )}`,
      )
    })
    .flat()
    .join('')
